import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars'

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';

import Button from '../../../../control/button/Button';
import Search from '../../../../control/search/Search';

const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px'
    },
    rootPaper: {
        width: '100%',
        ...theme.paperPadding
    },
    search: {
        marginBottom: '1%',
        width: '100%',
        [theme.breakpoints.down('xs')]: {
            marginTop: '3%'
        },
        [theme.breakpoints.down('sm')]: {
            marginBottom: '3%'
        }
    },
    btnAdd: {
        minWidth: '180px',
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    divider: {
        margin: '24px 0px'
    }
}));

const User = ({
    children,
    txtSearch,

    onSearch,
    permisAdd,
    onAddClick
}) => {
    const classes = useStyles();

    return (
        <Scrollbars universal={true}>
            <Grid container className={classes.root}>
                <Paper className={classes.rootPaper}>
                    <Search
                        iniValue={txtSearch}
                        onSearchClick={onSearch}
                        waterMark="รหัสพนักงาน, ชื่อ-นามสกุลพนักงาน, ชื่อกลุ่มผู้ใช้งาน"
                    />
                    <Divider className={classes.divider} />
                    <Grid item xs={12}>
                        <Grid item xs={12} container justify="space-between" className={classes.titleResult}>
                            <Grid item style={{ fontSize: '33px', marginLeft: '5px' }}>
                                ผลลัพธ์การค้นหา
                            </Grid>
                            {permisAdd && (
                                <Grid item>
                                    <Button
                                        label="เพิ่มผู้ใช้งาน"
                                        onClick={onAddClick}
                                        className={classes.btnAdd}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        <Grid item xs={12} >
                            {children}
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Scrollbars>
    );
};

export default User;
